import * as deepmerge from "deepmerge";

const _default = {
	black: "black",
	white: "white",
	red: "red",
	green: "green",
	blue: "blue",
	checkedBlack: "#000000",
	checkedGreen: "#008800",
	checkedBlue: "#215EBD",
	appBar: {
		sideMenuIcon: {
			name: "bars",
			color: "white",
			size: 30
		},
		container: {
			backgroundColor: "#121212"
		},
		activityName: {
			color: "white"
		},
		timer: {
			wrapper: {
			},
			containerDigits: {

			},
			timerDigits: {
				fontSize: 48,
				color: "white",
				fontWeight: "bold",
				fontFamily: "Courier"
			},
			containerLabels: {
				backgroundColor: "#444444"
			},
			label1Text: {
				color: "white",
				fontSize: 14
			},
			label2Text: {
				color: "white",
				fontSize: 20
			},
			progressBarContainer: {
				backgroundColor: "#444444"
			},
			progressBar: {

			},
			progressBarLessThan50PercentDone: {
				backgroundColor: "lightgreen"
			},
			progressBar50To75PercentDone: {
				backgroundColor: "orange"
			},
			progressBarOver75PercentDone: {
				backgroundColor: "red"
			}
		},
		fixedValues: {
			rowLayout: {
				container: {
					display: "flex",
					width: "100%",
					flex: 1,
					flexWrap: "wrap",
					flexDirection: "row"
				},
				fixedValue: {
					padding: 10,
					paddingVertical: 5,
					justifyContent: "center",
				},
				fixedValueNotFirst: {
					padding: 10,
					paddingVertical: 5,
					justifyContent: "center",
					borderLeftWidth: 1,
					borderLeftColor: "lightgray",
					borderLeftStyle: "solid"
				}
			},
			columnLayout: {
				container: {
					display: "flex",
					width: "100%",
					flex: 1,
					alignItems: "flex-end",
					justifyContent: "center"
				},
				fixedValue: {
					padding: 10,
					paddingVertical: 5,
					justifyContent: "center",
				},
				fixedValueNotFirst: {
					padding: 10,
					paddingVertical: 5,
					justifyContent: "center",
					borderTopWidth: 1,
					borderTopColor: "lightgray",
					borderTopStyle: "solid"
				}
			}
		}
	},
	breadcrumb: {
		container: { position: "relative", width: "100%", height: 40, backgroundColor: "#444444", display: "flex", flexDirection: "row", borderBottomWidth: 1, borderBottomColor: "#888888", borderBottomStyle: "solid" },
		breadcrumbBar: { flex: 1, maxWidth: "100%", flexDirection: "row", display: "flex", paddingLeft: 10, paddingRight: 10, height: "100%", overflow: "hidden",alignItems:"center" },
		breadcrumbBarExpanded: { backgroundColor: "darkgray" },
		dialog: {
			container: { position: "absolute", top: 0, left: 0, right: 0, width: "100%", bottom: 0, backgroundColor: "rgba(68,68,68,.8)", display: "flex", zIndex: 5, overflowX: "hidden" },
			closeButton: { width: 34, height: 34, borderRadius: 17, backgroundColor: "#888888", display: "flex", justifyContent: "center", alignItems: "center", borderWidth: 1, borderColor: "white", marginTop: 3, marginRight: 5, marginLeft: 5, cursor: "pointer" },
			closeButtonIconStyles: { color: "white" },
			closeButtonIcon: "times",
			navStackRow: {
				display: "flex",
				justifyContent: "center",
				alignItems: "flex-start",
				flex: 0,
				height: 50,
				width: "100%",
				borderBottom: "1px solid lightgray",
				padding: 5
			},
			navStackDismissRow: {
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				flex: 0,
				height: 50,
				width: "100%",
				padding: 5,
				marginTop: 10
			},
			itemRow: {
				display: "flex",
				flexDirection: "row",
				justifyContent: "flex-start",
				alignItems: "center",
				flex: 0,
				width: "100%",
				height: 40,
				borderBottom: "1px solid lightgray",
				padding: 5,
				cursor: "pointer", overflow: "hidden"
			},
			itemRowText: { color: "white", flex: 1, height: 30, textOverflow: "ellipsis", lineHeight:"30px",overflow:"hidden", whiteSpace:"nowrap" },
			itemRowSelected: {
				backgroundColor: "rgba(255,255,255,.4)",
				borderLeft:"3px solid white",
				paddingLeft: 2
			},
			itemRowSelectedText: { color: "white", flex: 1, height: 30, textOverflow: "ellipsis", lineHeight: "30px", overflow: "hidden" },
			itemRowNotVisible: {
				opacity: 0.8
			},
			sectionRow: {
				display: "flex",
				flexDirection: "row",
				justifyContent: "flex-start",
				alignItems: "center",
				flex: 0,
				width: "100%",
				height: 40,
				borderBottom:"1px solid lightgray",
				padding: 5,
				cursor: "pointer", overflow: "hidden"
			},
			sectionRowText: { color: "white", flex: 1, height: 30, textOverflow: "ellipsis", lineHeight: "30px", overflow: "hidden", whiteSpace: "nowrap" },
			sectionRowSelected: {
				backgroundColor: "rgba(255,255,255,.3)"
			},
			sectionRowSelectedText: { color: "white", flex: 1, height: 30, textOverflow: "ellipsis", lineHeight: "30px" },
			sectionRowNotVisible: {
				opacity: 0.8
			},
			listRow: {
				display: "flex",
				flexDirection: "row",
				justifyContent: "flex-start",
				alignItems: "center",
				position: "relative",
				flex: 0,
				width: "100%",
				height: 40,
				borderBottom: "1px solid lightgray",
				padding: 5,
				cursor: "pointer", overflow: "hidden"
			},
			listRowText: { color: "white", flex: 1, height: 30, textOverflow: "ellipsis", lineHeight: "30px", overflow: "hidden", whiteSpace: "nowrap" },
			listRowSelected: {
				backgroundColor: "rgba(255,255,255,.2)"
			},
			listRowSelectedText: { color: "white", flex: 1, height: 30, textOverflow: "ellipsis", lineHeight: "30px" },
			listRowNotVisible: {
				opacity: 0.8
			},
			expandCollapseButton: {
				marginRight: 5,
				backgroundColor: "#4A4A4A",
				display: "flex",
				justifyContent: "center",
				alignItems: "center"
			},
			treeFunctionBarWrapper: {
				width: "100%",
				display: "flex",
				flexDirection: "row",
				justifyContent: "space-between",
				alignItems: "center",
				padding: "10px 5px 10px 5px",
				backgroundColor: "rgba(0,0,0,.1)",
				borderTop: "1px solid white",
				borderBotton: "2px solid white"
			},
			searchBox: {
				flex: 1,
				backgroundColor: "#1F1F1F",
				color: "white",
				height: 30,
				borderRadius: 5,
				border:0,
				paddingRight: 5,
				paddingLeft: 30
			},
			functionButtons: {
				// flex: 1,
				display: "flex",
				flexDirection: "row",
				justifyContent: "flex-start",
				alignItems: "center",
				height: 30
			},
			functionButton: {
				width: 30,
				height: 30,
				display: "flex",
				justifyContent: "center",
				backgroundColor: "#1F1F1F",
				borderRadius: 5,
				alignItems: "center",
				cursor: "pointer"
			},
			functionButtonText: {
				color: "white",
				fontSize: 16
			},
			structureModeRow: {
				flex: 1, width: "100%", flexDirection: "row", height: 100, borderBottom: "1px solid lightgray", padding: "0 10px 0 10px", display: "flex",
				cursor: "pointer" },
			structureModeRowSelected: { backgroundColor: "rgba(255,255,255,.3)" },
			structureModeRowFunctions: { backgroundColor: "#1F1F1F", borderTop: "2px solid black", alignItems: "center", justifyContent: "center", flex: 0.5, display: "flex" },
			structureModeRowButton: {
				width: 120, height: 35, backgroundColor: "red", borderRadius: 5, justifyContent: "center", alignItems: "center", display: "flex",
				cursor: "pointer" },
			structureModeRowButtonLabel: { color: "white" }
		},
		chevron: { width: 20, height: "100%", display: "flex", justifyContent: "center", alignItems: "center" },
		chevronIcon: "chevron-right",
		chevronIconStyles: { color: "#999999" },
		historyButton: {
			container: { display: "flex", flexDirection: "row", width: 69, height: 34, marginTop: 3, marginLeft: 3, marginRight: 3, backgroundColor: "#888888", position: "relative", borderRadius: 5, alignItems: "center" },
			buttons: {
				goBack: { display: "flex", justifyContent: "center", alignItems: "center", flex: 1, cursor: "pointer"},
				goBackIcon: "arrow-left",
				goBackIconStyles: { fontWeight: "bold", color: "white" },
				toggleHistory: { display: "flex", justifyContent: "center", alignItems: "center", flex: 1, height:"100%", paddingBottom: 4,cursor:"pointer" },
				toggleHistoryIcon: "sort-down",
				toggleHistoryIconStyles: { fontWeight: "bold", color: "white" },
			},
			buttonSeparator: { height: "80%", width: 1, backgroundColor: "lightgray" }
		},
		itemStyles: {
			position: "relative",
			// height: 20,
			display: "flex",
			justifyContent: "flex-start",
			alignItems: "flex-start",
			paddingLeft: 10,
			paddingRight: 10,
			flex:1,
			cursor: "pointer",
			color: "white",
			lineHeight: "20px",
			overflow: "hidden",
			maxHeight: 40
		},
		itemSelectedStyles: {
			backgroundColor: "#888888"
		},
		itemOverflowStyles: {
			position: "absolute",
			right: 0,
			top: 20,
			height: 20,
			width: 80,
			background: "linear-gradient(45deg, transparent, #444444)"
		},
		itemOverflowSelectedStyles: {
			background: "linear-gradient(45deg, transparent, darkgray)"
		},
		itemTextStyles: { flex: 1, color: "white", textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" },
		textOverFlowGradient: {
			startColor: "rgba(68,68,68,0)",
			endColor: "rgba(68,68,68,.8)"
		}
	},
	commentsModal: {
		container: {
			backgroundColor:"#F9A200"
		}
	},
	quickBar: {
		container: {
			flex: 0,
			alignItems: "center",
			justifyContent: "space-between",
			backgroundColor: "black",
			padding: 5,
			position: "relative",
			height: "100%",
			width: "100%",
			display: "flex",
			flexDirection: "row",
			paddingLeft: 10,
			paddingRight: 10
		}
	},
	attachments: {
		icon: {
			color: "black"
		},
		selectedIcon: {
			color: "white"
		}
	},
	contentPanel: {
		bgColor: "#ffffff",
		homeBgColor: "#ffffff",
	},
	placeholder: {
		color: "#eeeeee",
		bgColor: "#ffffff"
	},
	placeholderStartProcedure: {
		iconName: "arrow-circle-up",
		color: "#eeeeee",
		fontSize:64
	},
	placeholderEndProcedure: {
		iconName: "thumbs-up",
		color: "#eeeeee",
		fontSize: 64
	},
	section: {
		backgroundColor: "#888888",
		color: "white",
		borderRadius: "5px",
		overflow: "hidden"
	},
	list: {
		backgroundColor: "#444444",
		color: "white",
		borderRadius: "5px",
		overflow:"hidden"
	},
	itemGroup: {
		container: {
			borderRadius: 15,
			borderColor: "lightgrey",
			borderWidth: 2,
			borderStyle: "solid",
			overflow: "hidden",
			position: "relative",
			paddingLeft: 10,
			paddingRight: 10,
			paddingTop: 5,
			paddingBottom: 10,
			marginLeft: 5,
			marginRight: 5,
			backgroundColor:"white"
		},
		header: {
			borderWidth: 0,
			borderRadius: 0,
			opacity: 1,
			marginTop: -10,
			marginLeft: -10,
			marginRight: -10
		},
		item: {
			borderRadius: 10,
			marginLeft: 0,
			marginTop: 5,
			marginRight: 0,
			marginBottom: 0
		},
		itemBorder: {
			disabledColor: "transparent",
			selectedColor: "green",
			selectedDisabledColor: "transparent",
			selectedDisabledColorFocusedMode: "transparent"
		}
	},
	item: {
		color: "black",
		disabledColor: "lightgray",
		selectedColor: "green",
		selectedDisabledColor: "#f8f8f8",
		selectedDisabledColorFocusedMode: "lightgray",
		base: {
			backgroundColor:"white",
			borderRadius: "15px",
			color:"black"
		},
		labelOnly: {
			backgroundColor: "#FFF8C6"
		},
		checked: {
			color: "green"
		},
		comments: {
			color: "#F9A200"
		},
		notes: {
			color: "#0000F9"
		},
		sketchPadImage: {
			color: "darkgreen"
		},
		media: {
			color: "purple"
		},
		yesNo: {
			yesButton: {
				selectedBorderColor: "darkgreen",
				selectedColor: "darkgreen",
				color: "darkgreen",
				disabledOpacity: .3,
				fontWeight:"bold"
			},
			noButton: {
				selectedBorderColor: "darkred",
				selectedColor: "darkred",
				color: "darkred",
				disabledOpacity: .3,
				fontWeight: "bold"
			},
			naButton: {
				selectedBorderColor: "darkblue",
				selectedColor: "darkblue",
				color: "darkblue",
				disabledOpacity: .3,
				fontWeight: "bold"
			}
		},
		textInput: {
			marginBottom:15,
			marginTop: 5,
			padding: 5,
			borderRadius: 5,
			borderStyle: "solid",
			borderColor: "#dddddd",
			backgroundColor: "white",
			color: "black"
		},
		textInputMultiline: {
			marginBottom: 15,
			height: 100,
			padding: 5,
			borderRadius: 5,
			borderStyle: "solid",
			borderColor:"#dddddd",
			backgroundColor: "white",
			color: "black"
		},
		linkColor: "blue",
		barcodeScanner: {
			textInput: {
				color: "black",
				backgroundColor: "white",
				padding: 3, borderColor: "gray", marginTop: 5
			},
			buttons: {
				scan: {
					display: "flex", backgroundColor: "skyblue", paddingLeft: 5, paddingRight: 5, marginLeft: 5, height: 30, width: 30, borderRadius: 5, justifyContent: "center", alignItems: "center", flexDirection: "row"
				},
				scanText: {
					color: "black", fontSize: 14
				},
				clear: {
					display: "flex", backgroundColor: "red", paddingLeft: 5, paddingRight: 5, marginLeft: 5, height: 30, width: 30, borderRadius: 5, justifyContent: "center", alignItems: "center", flexDirection: "row"
				},
				clearText: {
					color: "white", fontSize: 14, fontWeight: "bold"
				}
			}
		},
		sketchPad: {
			backgroundColor: "white",
			color: "gray",
			borderStyle: "dashed",
			borderColor: "gray",
			borderWidth: 3
		},
		picker: {
			basic: {
				backgroundColor: "white"
			},
			placeholder: {
				color: "rgba(0, 35, 102,.9)"
			},
			buttons: {
				backgroundColor: "transparent",
				color: "blue",
				fontWeight:"bold",
				selectedBorderColor:"blue"
			},
		},
		choice: {
			checkbox: {
				backgroundColor: "white",
				borderColor: "black",
				borderWidth: 2,
				checkedIconName: "check",
				borderRadius: 5,
				borderStyle: "solid"
			},
			radio: {
				backgroundColor: "white",
				borderColor: "black",
				borderWidth: 2,
				checkedIconName: "circle",
				borderRadius: 20,
				borderStyle: "solid"
			},
			text: {
				color: "black"
			}
		},
		check: {
			backgroundColor: "white",
			borderColor: "black",
			borderWidth: 2,
			checkedIconName: "check",
			borderRadius: 5,
			borderStyle: "solid"
		},
		datePicker: {
			backgroundColor: "white",
			color: "black"
		},
		mediaPicker: {
			button: {
				color: "blue",
				fontWeight:"bold"
			},
			imagePlaceholder: {
				width: 100, height: 100, borderStyle: "dashed", borderWidth: 1, borderColor: "gray" 
			}
		},
		addressSearch: {
			panel: {
				backgroundColor: "white",
				padding:10
			},
			text: {
				color: "black",
				fontWeight: "bold"
			}
		},
		buttonOk: {
			underlayColor: "lightgray",
			height: 40,
			marginTop: 10,
			borderStyle: "solid",
			borderWidth: 1,
			borderColor: "lightgray",
			borderRadius: 5,
			backgroundColor: "white",
			fontWeight: "bold",
			color: "royalblue",
			fontSize: 16,
			fontFamily:"'Roboto', sans-serif"
		},
		ranking: {
			panel: {},
			dialogs: {
				editFullscreen: {
					wrapper: { backgroundColor: "white" },
					header: {
						height: 70, borderBottomWidth: 1, borderBottomColor: "lightgray", padding: 10
					},
					footer: {
						borderTopWidth: 1, borderTopColor: "lightgray", padding: 10, paddingLeft: 0
					}
				},
				insertItem: {
					wrapper: { backgroundColor: "white" },
					header: {
						height: 70, borderBottomWidth: 1, borderBottomColor: "lightgray", padding: 10
					},
					footer: {
						borderTopWidth: 1, borderTopColor: "lightgray", padding: 10, paddingLeft: 0
					}
				}
			},
			buttons: {
				edit: { display: "flex", width: 100, backgroundColor: "skyblue", height: 40, borderRadius: 5, justifyContent: "center", alignItems: "center", flexDirection: "row", borderWidth: 1, borderColor: "lightgray", borderStyle: "solid" },
				editText: { color: "white", fontSize: 16, fontWeight: "bold" },
				editFullscreen: { display: "flex", width: 100, backgroundColor: "skyblue", height: 40, borderRadius: 5, justifyContent: "center", alignItems: "center", flexDirection: "row", borderWidth: 1, borderColor: "lightgray", borderStyle: "solid" },
				editFullscreenText: { color: "white", fontSize: 16, fontWeight: "bold" },
				editFullscreenDone: { display: "flex", backgroundColor: "skyblue", height: 40, borderRadius: 5, width: 100, flexDirection: "row", justifyContent: "center", alignItems: "center", borderWidth: 1, borderColor: "lightgray", borderStyle: "solid" },
				editFullscreenDoneText: { color: "white", fontWeight: "bold", fontSize: 16 },
				insertDone: { display: "flex", backgroundColor: "skyblue", height: 40, borderRadius: 5, width: 100, flexDirection: "row", justifyContent: "center", alignItems: "center", borderWidth: 1, borderColor: "lightgray", borderStyle: "solid" },
				insertDoneText: { color: "white", fontWeight: "bold", fontSize: 16 },
				insertCancel: { display: "flex", backgroundColor: "red", height: 40, borderRadius: 5, width: 100, flexDirection: "row", justifyContent: "center", alignItems: "center", borderWidth: 1, borderColor: "lightgray", borderStyle: "solid" },
				insertCancelText: { color: "white", fontWeight: "bold", fontSize: 16 },
				doneEditing: { display: "flex", width: 100, backgroundColor: "skyblue", height: 40, borderRadius: 5, justifyContent: "center", alignItems: "center", flexDirection: "row", borderWidth: 1, borderColor: "lightgray", borderStyle: "solid" },
				doneEditingText: { color: "white", fontSize: 16, fontWeight: "bold" }
			},
			placeholder: {
				icons: {
					default: "plus",
					hover:"plus-circle"
				},
				panel: {
					display: "flex",
					width: "100%",
					borderWidth: 1,
					borderStyle: "dashed",
					borderRadius: 10,
					height: 50,
					backgroundColor: "white",
					alignItems: "center",
					justifyContent: "center",
					marginBottom: 10,
					padding: 10
				},
				text: {
					fontWeight: "bold",
					color: "black",
					fontSize: 18
				}
			},
			item: {
				panel: {
					display: "flex",
					minHeight: 50,
					borderRadius: 10,
					backgroundColor: "rgb(211, 211, 211)",

					justifyContent: "center",
					marginBottom: 10,
					padding: 10
				},
				text: {
					color: "black",
					fontSize: 14
				},
				panelDragging: {
					display: "flex",
					minHeight: 50,
					borderRadius: 10,
					backgroundColor: "rgba(211, 211, 211, .8)",

					justifyContent: "center",
					marginBottom: 10,
					elevation: 4,
					shadowOffset: { width: 2, height: 2 },
					shadowColor: "grey",
					shadowOpacity: 0.3,
					shadowRadius: 5,
					padding: 10
				},
				panelDraggingText: {
					color: "black",
					fontSize: 14
				},
				panelSelectableForInsert: {
					display: "flex",
					minHeight: 50,
					borderRadius: 10,
					backgroundColor: "rgb(211, 211, 211)",

					justifyContent: "center",
					marginBottom: 10,
					padding: 10
				},
				panelSelectableForInsertText: {
					color: "black",
					fontSize: 14
				},
				panelSelectableForInsertSelected: {
					display: "flex",
					minHeight: 50,
					borderRadius: 10,

					justifyContent: "center",
					marginBottom: 10,
					backgroundColor: "skyblue",
					color: "white",
					padding: 10
				},
				panelSelectableForInsertSelectedText: {
					color: "white",
					fontSize: 14
				}
			}
		}
	},
	itemSimple: {
		bgColor: "#f4f4f4",
		labelOnlyBgColor: "#FFF8C6",
		selectedColor: "green",
		selectedDisabledColor: "#ffffff"
	},
	home: {
		footer: {
			color: "#666666"
		}
	},
	modal: {
		content: {
			bgColor: "#ffffff"
		}
	},
	comments: {
		sketchPad: {
			container: {
				bgColor: "lightgray"
			},
			canvas: {
				bgColor: "white",
				penColor: "blue"
			}
		}
	},
	nav: {
		bgColor: "#ffffff",
		profile: {
			bgColor: "#B2DBFF",
			color: "black",
			borderBottomColor: "#4C9DE5",
			buttonTxtColor: "white"
		},
		item: {
			color: "black",
			disabledColor: "gray",
			selectedColor: "blue"
		},
		section: {
			color: "#121212",
			iconColor: "#121212"
		},
		picker: {
			title: {
				color: "#4681b9"
			},
			item: {
				color: "black",
				iconColor: "#121212"
			}
		},
		learnMore: {
			color: "blue"
		},
		hr: {
			color: "#eeeeee",
			bgColor: "#cccccc"
		}
	},
	checkbar: {
		check: {
			color: "darkgreen",
			bgColor: "#eeffee"
		},
		skip: {
			color: "darkblue",
			bgColor: "#eeeeff"
		},
		locateItem: {
			color: "#000000",
			bgColor: "#eeeeee"
		},
		birdseyeView: {
			color: "#000000",
			bgColor: "#dddddd"
		},
		listen: {
			color: "green",
			disabledColor: "#168e8c",
			bgColor: "#e5f9f9"
		},
		emergency: {
			color: "#cc0000",
			bgColor: "#ffcccc"
		},
		switchShowMode: {
			bgColor: "rgb(40,40,40)",
			color: "lightgray"
		}
	}
};

const nightMode = deepmerge.all([_default, {
	black: "black",
	white: "white",
	red: "red",
	green: "green",
	blue: "blue",
	checkedBlack: "#000000",
	checkedGreen: "#008800",
	checkedBlue: "#215EBD",
	contentPanel: {
		bgColor: "#000000",
		homeBgColor: "#444444"
	},
	placeholder: {
		color: "#222222",
		bgColor: "#000000"
	},
	item: {
		color: "white",
		disabledColor: "#222222",
		selectedColor: "#FF962A",
		selectedDisabledColor: "#333333",
		comments: {
			color: "#F9A200"
		},
		notes: {
			color: "#0000F9"
		},
		sketchPadImage: {
			color: "darkgreen"
		},
		media: {
			color: "purple"
		}
	},
	itemSimple: {
		bgColor: "#616161",
		labelOnlyBgColor: "#66634f",
		selectedColor: "#008800",
		selectedDisabledColor: "#000000"
	},
	home: {
		footer: {
			color: "#666666"
		}
	},
	modal: {
		content: {
			bgColor: "lightgray"
		}
	},
	comments: {
		sketchPad: {
			container: {
				bgColor: "lightgray"
			},
			canvas: {
				bgColor: "black",
				penColor: "yellow"
			}
		}
	},
	nav: {
		bgColor: "#888888",
		profile: {
			bgColor: "#4C9DE5",
			color: "white",
			borderBottomColor: "#B2DBFF",
			buttonTxtColor: "black"
		},
		item: {
			color: "black",
			disabledColor: "#444444",
			selectedColor: "blue"
		},
		section: {
			color: "#121212",
			iconColor: "#121212"
		},
		picker: {
			title: {
				color: "#7da6ce"
			},
			item: {
				color: "black",
				iconColor: "#121212"
			}
		},
		learnMore: {
			color: "blue"
		},
		hr: {
			color: "#eeeeee",
			bgColor: "#444444"
		}
	},
	checkbar: {
		check: {
			color: "darkgreen",
			bgColor: "#beccbe"
		},
		skip: {
			color: "darkblue",
			bgColor: "#bebecc"
		},
		locateItem: {
			color: "#000000",
			bgColor: "#bebebe"
		},
		birdseyeView: {
			color: "#000000",
			bgColor: "#dddddd"
		},
		listen: {
			color: "green",
			disabledColor: "#168e8c",
			bgColor: "#b7c7c7"
		},
		emergency: {
			color: "#cc0000",
			bgColor: "#cca3a3"
		},
		switchShowMode: {
			bgColor: "rgb(40,40,40)",
			color: "lightgray"
		}
	}
}]);

export default {
	default: _default,
	nightMode
};